import React, { type PropsWithChildren } from 'react';
import { Platform } from 'react-native';
import { FullWindowOverlay } from 'react-native-screens';

import { Portal } from '@gorhom/portal';

import { useIsInModalStack } from '../../../../../../routing/hooks/useIsInModalStack';

// ─────────────────────────────────────────────────────────────────────────────

/**
 * Portals render in the app root, which iOS covers with native modals, so modal
 * stacks render the content in a full window overlay above them instead.
 */
export const NavbarPortal = (props: PropsWithChildren) => {
  const { children } = props;

  const isInModalStack = useIsInModalStack();

  // ─────────────────────────────────────────────────────────────────────

  if (Platform.OS === 'ios' && isInModalStack) {
    return <FullWindowOverlay>{children}</FullWindowOverlay>;
  }

  return <Portal>{children}</Portal>;
};
